import {
  GET_TASK_TYPE_LIST_FAILURE,
  GET_TASK_TYPE_LIST_REQUEST,
  GET_TASK_TYPE_LIST_SUCCESS,
  UPDATE_TASK_TYPE_STATUS_SUCCESS,
} from "../actionTypes";
import { updateStatusFun } from "../stateHelperFunction";

export interface taskTypeListState {
  loading: boolean;
  taskTypeList: any;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: taskTypeListState = {
  loading: false,
  taskTypeList: {},
  error: "",
};

export const taskTypeListReducer = (state = initialState, action: action) => {
  switch (action.type) {
    case GET_TASK_TYPE_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_TASK_TYPE_LIST_SUCCESS:
      return {
        loading: false,
        taskTypeList: action.payload,
        error: "",
      };
    case GET_TASK_TYPE_LIST_FAILURE:
      return {
        loading: false,
        taskTypeList: {},
        error: action.payload,
      };
    case UPDATE_TASK_TYPE_STATUS_SUCCESS:
      return updateStatusFun(
        state,
        "taskTypeList",
        action.payload.data.records.Id
      );
    default:
      return state;
  }
};
